

































import {Vue, Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import bookingDefault from '@/instance-defaults/bookingDefault';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import VendorClaimTooltip from '@/components/Views/Vendor/VendorClaimTooltip.vue';
import PaymentBadge from '@/components/Views/UI/PaymentBadge.vue';
import {CLAIM_STATUS, multiNil, nil} from '@/common';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import {DateTime} from 'luxon';
import {FeathersVuexFindAll, getZonedBookingDate} from '@/utils';
import BookingMetadataMixin from '@/mixins/BookingMetadataMixin.vue';
import BookingActions from '@/components/Views/UI/BookingActions.vue';
import CardholderInfoBadge from "@/components/Views/UI/CardholderInfoBadge.vue";
import BookingDateMixin from '@/mixins/BookingDateMixin.vue';
@Component({
    components: {
        CardholderInfoBadge,
        BookingActions,
        PaymentBadge,
        VendorClaimTooltip,
    },
})
export default class BookingListItem extends Mixins(UserRoleMixin, CurrencyMixin, BookingDateMixin, BookingMetadataMixin) {

    @Prop({default: () => null})
    public booking!: any;

    @Prop({default: false})
    public hideActions!: boolean;

    @Prop({default: false})
    public hideCardHolder!: boolean;

    @Prop({default: false})
    displayLocalTimezone!: boolean;

    @Watch('booking')
    public onBookingChanged(value: any, oldValue: any) {
        this.getBookingMetadata();
    }
    public purchasable = null;
    public claim = null;
    public category = null;
    public tier = null;
    public cardHolderName = null;
    public claims = [];
    public loading = true;

    public created() {
        this.getBookingMetadata();
    }

    public asGuest(guestAmount: number): string {
        return `${guestAmount} Guest${guestAmount > 1 ? 's' : ''}`;
    }

    public async getBookingMetadata() {
        if (nil(this.booking)) { return; }
        this.loading = true;
        const {VendorClaim} = this.$FeathersVuex;
        const {vendorModel} = this.$store.state.auth.user;
        this.claims = await this.getClaims(this.booking, true);
        if (!nil(vendorModel)) {
            this.claim = await this.getClaim(this.booking, vendorModel._id);
        }
        this.category = await this.getCategory(this.booking);
        this.tier = await this.getTier(this.booking);
        this.purchasable = await this.getPurchasable(this.booking);
        this.cardHolderName = await this.getCardHolderName(this.booking);
        this.loading = false;
    }
    get proPayment() {
        if (nil(this.booking)) {
            return 0;
        }
        const price = this.calculateBookingPrice(this.booking);
        const tip = price * .2;
        const pay = price * this.tierCut;
        return pay + tip;
    }
    get address() {
        if (multiNil(this, 'booking.address')) { return ''; }
        return this.booking.address;
    }
    get tierName() {
        return nil(this.tier) ? '' : this.tier.name;
    }
    get tierCut() {
        return nil(this.tier) ? 1 : this.tier.vendorCut;
    }
    get serviceName() {
        return nil(this.purchasable) ? '' : this.purchasable.name;
    }
    get bookingUrl() {
        return nil(this.booking) ? '' : `/dashboard/bookings/${this.booking._id}`;
    }
    get orderUrl() {
        return multiNil(this, "booking.order") ? '' : `/dashboard/orders/${this.booking.order}`;
    }
    get purchaserEmail(){
        return multiNil(this, "booking.purchaserModel") ? '' : `${this.booking.purchaserModel.email}`;
    }
    get purchaserPhone(){
        return multiNil(this, "booking.purchaserModel") ? '' : `${this.booking.purchaserModel.phone}`;
    }
    get bookingGuests() {
        if (multiNil(this, 'booking.guests')) { return 0; }
        return this.booking.guests;
    }
    get activeBookingDate(){
        return this.displayLocalTimezone ? this.zonedBookingDate.toLocal() : this.zonedBookingDate;
    }
    get bookingHourStart() {
        if (multiNil(this, 'booking.date')) { return '?'; }
        return this.activeBookingDate.toFormat('h:mm a')
    }
    get bookingHourEnd(){
        if (multiNil(this, 'booking.date')) { return '?'; }
        return this.activeBookingDate.plus({hours:this.booking.duration}).toFormat('h:mm a')
    }
    get bookingTimezone(){
        return this.displayLocalTimezone ? "Local Timezone" : "Booking Timezone"
    }
    get bookingWasSplit(){
        return nil(this.booking) ? false : !nil(this.booking.groupKey);
    }
}
